import {
  Dialog,
  DialogContent,
  Stack,
  Box,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export const FlowCloseDialog = ({ open, onAgree, onCancel }) => {
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '400px',
          borderRadius: '13px',
          background: 'var(--White, #FFF)',
        },
      }}
    >
      <DialogContent
        dividers
        sx={{
          p: 3,
          border: 'none',
          position: 'relative',
        }}
      >
        <Stack spacing={2} sx={{ textAlign: 'center' }}>
          <img src="/alert-triangle.png" alt="alert-triangle" style={{ margin: 'auto' }} />

          <DialogContentText
            component={Box}
            sx={{
              '& > p': {
                fontWeight: 'bolder',
              },
            }}
          >
            Are you sure you want to exit the current Flow?
          </DialogContentText>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack
          direction="row"
          spacing={2}
          width="100%"
          paddingX={2}
          paddingBottom={2}
          justifyContent="center"
          alignItems="center"
        >
          <Button
            fullWidth
            variant="outlined"
            color="info"
            onClick={onCancel}
            sx={{ height: '46px' }}
          >
            No
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="info"
            onClick={onAgree}
            autoFocus
            sx={{ height: '46px' }}
          >
            Yes
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
